import { AUTH_SUCCESS, LOGOUT } from 'JS/actionCreators/authActions';
import { SUBMIT_USERPERSONA_MODAL } from 'JS/actionCreators/marketingActions';

import { getGATracker, getGAWhitelist, getHSTracker, getHSWhitelist } from '../../shared/helpers/tracking';
import { getStore } from '../index';

const GA_CUSTOM_DIMENSION_MAP = {
  'Scribely Subscription Type': 'dimension1',
  'Scribely User Organisation': 'dimension2',
  'Scribely User Intention': 'dimension3'
};

let gaTrack = getGATracker();
let hsTrack = getHSTracker();

function actionCapture() {
  return next => action => {
    const state = getStore().getState();
    let matchedAction = '';

    if ([AUTH_SUCCESS].includes(action.type)) {
      gaTrack.ga('set', 'userId', `${action.user.id}`);
      gaTrack.ga('set', GA_CUSTOM_DIMENSION_MAP['Scribely Subscription Type'], action.user.accountType);
    }

    if (action.type === LOGOUT) {
      gaTrack.ga('set', 'userId', '');
      gaTrack.ga('set', GA_CUSTOM_DIMENSION_MAP['Scribely Subscription Type'], '');
    }

    if (action.type === SUBMIT_USERPERSONA_MODAL) {
      const { answers } = action;
      const userType = answers.user_type === 'other' ? `other:${answers.user_type_text}` : answers.user_type;
      gaTrack.ga('set', GA_CUSTOM_DIMENSION_MAP['Scribely User Organisation'], userType);

      // |content_marketing|explainer|other:stuff|
      gaTrack.ga('set', GA_CUSTOM_DIMENSION_MAP['Scribely User Intention'], `|${answers.intention.join('|')}|`);
    }

    /*
     * Log valid event and page view with GA
     */
    const gaWhitelist = getGAWhitelist(action);
    if ((matchedAction = gaWhitelist[action.type])) {
      gaTrack.event(matchedAction);
    } else if (action.type === '@@router/LOCATION_CHANGE') {
      if (action.payload.location.pathname.indexOf('reset-password') >= 0) {
        gaTrack.pageview('/app/reset-password');
        return;
      }

      gaTrack.pageview(`/app${action.payload.location.pathname}`);
    }

    /*
     * Log valid event with Hubspot
     */
    const hsWhitelist = getHSWhitelist(action);
    if ((matchedAction = hsWhitelist[action.type])) {
      hsTrack.event(matchedAction, matchedAction.email || state.auth.currentUser.email);
    }

    return next(action);
  };
}

const callActionCaptire = () => actionCapture;

export default callActionCaptire;
